import React, { Component } from 'react'

import Input from '@Form/Input'
import Checkbox from '@Form/Checkbox'
import Select from '@Form/Select'

class Settings extends Component {
    changeSetting = ({ value, name }) => {
        const { kpi } = this.props
        const { settings } = kpi

        settings[name] = value
    }

    render() {
        const { kpi } = this.props
        const { settings } = kpi

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    padding: '10px',
                }}
            >
                <h4>Settings</h4>
                <Checkbox
                    name="allowQuadrantAnalysis"
                    label="Allow Quadrant Analysis"
                    defaultChecked={settings.allowQuadrantAnalysis}
                    className="exploriNativeCheckbox"
                    onBlur={this.changeSetting}
                />
                <Input
                    name="min"
                    label="Min"
                    isNumeric
                    defaultValue={settings.min}
                    onBlur={this.changeSetting}
                />
                <Input
                    name="max"
                    label="Max"
                    isNumeric
                    defaultValue={settings.max}
                    onBlur={this.changeSetting}
                />
                <Input
                    name="decimals"
                    label="Decimals"
                    isNumeric
                    isMandatory
                    defaultValue={settings.decimals}
                    onBlur={this.changeSetting}
                />
                <Select
                    name="format"
                    label="Format"
                    options={[
                        { label: 'Numeric', value: 'numeric' },
                        { label: 'Currency', value: 'currency' },
                        { label: '%', value: '%' },
                    ]}
                    defaultValue={settings.format}
                    onBlur={this.changeSetting}
                />
            </div>
        )
    }
}

export default Settings
